/* eslint-disable react/prop-types */
import CorrelatedAreaComponent from "./correlated-area";
import { useState, useEffect } from "react";
import * as announcementHelper from "@/common/announcement-helper";

const ANNOUNCEMENTS_PLACEHOLDER = "Seleziona i bandi correlati";
const SERVICES_PLACEHOLDER = "Seleziona i servizi correlati";
const DATE_PLACEHOLDER = new Date("01/01/2021");
function CorrelatedArea({
  announcement,
  updateAnnouncement,
  announcements,
  services,
}) {
  const [correlationExpire, setCorrelationExpire] = useState(
    announcement.correlationExpire
      ? new Date(announcement.correlationExpire)
      : DATE_PLACEHOLDER
  );

  const [correlatedAnnouncements, setCorrelatedAnnouncements] = useState(
    initializeList(
      getOpenAnnoucements({ announcements }),
      announcement.correlatedAnnouncements
    )
  );
  const [selectedCorrelatedAnnouncements, setSelectedCorrelatedAnnouncements] =
    useState(
      announcement.correlatedAnnouncements
        ? announcement.correlatedAnnouncements
        : ANNOUNCEMENTS_PLACEHOLDER
    );

  const [correlatedServices, setCorrelatedServices] = useState(
    initializeList(services, announcement.correlatedServices)
  );
  const [selectedCorrelatedServices, setSelectedCorrelatedServices] = useState(
    announcement.correlatedServices
      ? announcement.correlatedServices
      : SERVICES_PLACEHOLDER
  );

  useEffect(() => {
    const announcementsOfInterest = correlatedAnnouncements.filter(
      ({ isSelected }) => isSelected === true
    );

    if (announcementsOfInterest?.length) {
      setSelectedCorrelatedAnnouncements(announcementsOfInterest);
    } else {
      setSelectedCorrelatedAnnouncements(ANNOUNCEMENTS_PLACEHOLDER);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [correlatedAnnouncements]);

  useEffect(() => {
    if (selectedCorrelatedAnnouncements !== ANNOUNCEMENTS_PLACEHOLDER) {
      updateAnnouncementWithId(
        "correlatedAnnouncements",
        correlatedAnnouncements,
        announcement
      );
    } else {
      updateAnnouncement("correlatedAnnouncements", [], announcement);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedCorrelatedAnnouncements]);

  useEffect(() => {
    const servicesOfInterest = correlatedServices.filter(
      ({ isSelected }) => isSelected === true
    );

    if (servicesOfInterest?.length) {
      setSelectedCorrelatedServices(servicesOfInterest);
    } else {
      setSelectedCorrelatedServices(SERVICES_PLACEHOLDER);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [correlatedServices]);

  useEffect(() => {
    if (selectedCorrelatedServices !== SERVICES_PLACEHOLDER) {
      updateAnnouncementWithId(
        "correlatedServices",
        correlatedServices,
        announcement
      );
    } else {
      updateAnnouncement("correlatedServices", [], announcement);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedCorrelatedServices]);

  const handleAnnouncementSelect = ({ name }) => {
    setCorrelatedAnnouncements(
      updateMuliChoiceList(name, correlatedAnnouncements)
    );
  };

  const handleServiceSelect = ({ name }) => {
    setCorrelatedServices(updateMuliChoiceList(name, correlatedServices));
  };

  const handleCorrelationExpireDateChange = (date) => {
    setCorrelationExpire(date);
    updateAnnouncement("correlationExpire", date.getTime(), announcement);
  };

  return (
    <CorrelatedAreaComponent
      announcements={correlatedAnnouncements}
      selectedAnnouncements={selectedCorrelatedAnnouncements}
      onAnnouncementSelect={handleAnnouncementSelect}
      services={correlatedServices}
      selectedServices={selectedCorrelatedServices}
      onServiceSelect={handleServiceSelect}
      isCorrelatedAnnouncementsValid={
        selectedCorrelatedAnnouncements !== ANNOUNCEMENTS_PLACEHOLDER
      }
      isCorrelatedServicesValid={
        selectedCorrelatedServices !== SERVICES_PLACEHOLDER
      }
      isCorrelationExpireValid={correlationExpire !== DATE_PLACEHOLDER}
      correlationExpire={correlationExpire}
      onCorrelationExpireDateChange={handleCorrelationExpireDateChange}
      announcement={announcement}
    />
  );
}

function getOpenAnnoucements({ announcements }) {
  var filteredAnnouncements = announcements.filter((announcement) => {
    const status = announcementHelper.getStatus({ announcement });
    return status !== announcementHelper.Status.CLOSED;
  });
  return filteredAnnouncements;
}

function updateAnnouncementWithId(property, list, announcement) {
  var ids = [];
  list.forEach(({ id, isSelected }) => {
    if (isSelected) {
      ids.push(id);
    }
  });
  announcement[`${property}`] = ids;
  return announcement;
}

function initializeList(list, selectedIds) {
  return list?.map((object) => {
    var found = selectedIds?.find((id) => id === object.id);

    return {
      ...object,
      isSelected: found !== undefined,
    };
  });
}

function updateMuliChoiceList(name, list) {
  return list.map((obj) => {
    return {
      ...obj,
      isSelected:
        obj.name === name || obj.title === name
          ? !obj.isSelected
          : obj.isSelected,
    };
  });
}

export default CorrelatedArea;
